module.exports = __webpack_public_path__ + "static/media/Apple Watch 42mm Silver Aluminum + Flat Silver Volt Nike Open.fd0268df.png";